export default function getDataSource(props) {
  if (props) {
    return props.dataSource || props.data;
  }
}